<template>
  <svg
    :width="props.size"
    :height="props.size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5 4L14.5 3H9.5L8.5 4H5V6H19V4H15.5ZM6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM8 9H16V19H8V9Z"
      :fill="props.color"
    />
  </svg>
</template>
<script setup lang="ts">
  const props = defineProps({
    size: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#444444',
    },
  })
</script>
